// Base component that adopts Bootstrap styles into its Shadow DOM. Extend this
// class for all community-portal components.
//
// Re-exported from the shared d3-kit `spa/` primitives (bundled via lit.js).
export { BaseComponent } from './lit.js';
